const csrfTokenElement = document.querySelector(
  'meta[name="csrf-token"]'
) as HTMLMetaElement
const csrfToken = csrfTokenElement?.getAttribute("content")

export default function AuthenticityTokenInput() {
  if (!csrfToken) return null

  return <input type="hidden" name="authenticity_token" value={csrfToken} />
}
